import { h } from 'preact';
import clsx from 'clsx';
import PlayIcon from './icons/play.svg';
import PauseIcon from './icons/pause.svg';
import MuteIcon from './icons/mute.svg';
import UnmuteIcon from './icons/unmute.svg';

const VideoControl = ({
  toggleType,
  handleClick,
  isActive,
  iconColor,
  className,
}) => {
  const isPause = toggleType === 'pause';
  let Icon;
  let ariaLabel;

  if (isPause) {
    Icon = isActive ? PauseIcon : PlayIcon;
    ariaLabel = isActive ? 'Pause video' : 'Play video';
  } else {
    Icon = isActive ? MuteIcon : UnmuteIcon;
    ariaLabel = isActive ? 'Mute video' : 'Unmute video';
  }

  return (
    <button
      type="button"
      data-video-control={toggleType}
      onClick={handleClick}
      className="block group"
      ariaLabel={ariaLabel}
    >
      <Icon
        style={{ color: iconColor }}
        className={clsx(
          'w-10 h-10 group-focus:ring-2 group-focus:ring-blue-500 focus:outline-none',
          className,
        )}
      />
    </button>
  );
};

export default VideoControl;
